import { render, staticRenderFns } from "./ThemeGroupbuyingEdit.vue?vue&type=template&id=1a15c44e&"
import script from "./ThemeGroupbuyingEdit.vue?vue&type=script&lang=js&"
export * from "./ThemeGroupbuyingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports